import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { BusinessAuthService } from '../services/business-auth.service';

/**
 * Solo cuentas con `isCompanyAdmin === true` (misma regla que el menú lateral).
 * Si no aplica, redirige a `/empresas/panel`.
 */
export const businessCompanyAdminGuard: CanActivateFn = () => {
  const auth = inject(BusinessAuthService);
  const router = inject(Router);

  return auth.fetchAccount().pipe(
    map((account) => {
      if (account?.isCompanyAdmin === true) {
        return true;
      }
      void router.navigateByUrl('/empresas/panel', { replaceUrl: true });
      return false;
    }),
    catchError(() => {
      const acc = auth.getBusinessAccount();
      if (acc?.isCompanyAdmin === true) {
        return of(true);
      }
      void router.navigateByUrl('/empresas/panel', { replaceUrl: true });
      return of(false);
    }),
  );
};
